var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaceVerificationSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qz961ctn7a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.334 2.333H3.501A1.167 1.167 0 0 0 2.334 3.5v5.833a1.167 1.167 0 1 0 2.333 0V4.667h4.667a1.167 1.167 0 1 0 0-2.334zm0 21H4.667v-4.666a1.167 1.167 0 0 0-2.333 0V24.5a1.167 1.167 0 0 0 1.167 1.167h5.833a1.166 1.166 0 1 0 0-2.334zm15.167-21h-5.834a1.167 1.167 0 0 0 0 2.334h4.667v4.666a1.167 1.167 0 1 0 2.333 0V3.5a1.167 1.167 0 0 0-1.166-1.167z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.229 17.784a.554.554 0 0 0-.752-.814 4.303 4.303 0 0 1-2.928 1.145 4.303 4.303 0 0 1-2.928-1.145.554.554 0 1 0-.752.814 5.408 5.408 0 0 0 3.68 1.439 5.408 5.408 0 0 0 3.68-1.44zM14.656 14.116V10.18a.554.554 0 1 0-1.107 0v3.937c0 .17-.138.308-.308.308h-.451a.554.554 0 0 0 0 1.107h.451c.78 0 1.415-.635 1.415-1.415zM18.472 11.727v-1.58a.523.523 0 0 0-1.046 0v1.58a.523.523 0 1 0 1.046 0zM9.273 12.25a.523.523 0 0 1-.523-.523v-1.58a.523.523 0 0 1 1.046 0v1.58a.523.523 0 0 1-.523.523z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.618 16.649a.991.991 0 0 1 1.345 1.456 5.846 5.846 0 0 1-3.976 1.555 5.845 5.845 0 0 1-3.977-1.555.991.991 0 0 1 1.345-1.456 3.867 3.867 0 0 0 2.632 1.029c.979 0 1.913-.366 2.631-1.03zm.594.643a4.74 4.74 0 0 1-3.225 1.26 4.74 4.74 0 0 1-3.226-1.26m6.45 0a.116.116 0 0 1 .159.17 4.97 4.97 0 0 1-3.383 1.323 4.97 4.97 0 0 1-3.383-1.323.116.116 0 0 1-.007-.164m0 0a.116.116 0 0 1 .165-.006l-.165.006zM13.549 10.179a.991.991 0 0 1 1.982 0v3.937c0 1.022-.83 1.853-1.852 1.853h-.452a.991.991 0 0 1 0-1.983h.322V10.18zm.991-.117a.116.116 0 0 0-.116.117v3.937a.745.745 0 0 1-.745.745h-.452a.116.116 0 0 0 0 .233h.452a.98.98 0 0 0 .977-.978V10.18a.116.116 0 0 0-.116-.117zM17.426 10.148a.96.96 0 0 1 1.92 0v1.58a.96.96 0 0 1-1.92 0v-1.58zm.96-.085a.085.085 0 0 0-.085.085v1.58a.085.085 0 0 0 .17 0v-1.58a.086.086 0 0 0-.085-.085zM9.71 10.063a.085.085 0 0 0-.085.085v1.58a.085.085 0 0 0 .17 0v-1.58a.085.085 0 0 0-.085-.085zm-.96.085a.96.96 0 0 1 1.92 0v1.58a.96.96 0 0 1-1.92 0v-1.58z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#fkhi4ajurb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 15.75a5.25 5.25 0 1 0 0 10.499 5.25 5.25 0 0 0 0-10.499z",
    fill: "#24E4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M19.925 23.625a.632.632 0 0 1-.45-.188l-1.791-1.804a.644.644 0 0 1 .45-1.093c.169 0 .33.066.45.185l1.341 1.351 3.49-3.516a.635.635 0 0 1 1.085.455c0 .169-.066.332-.184.452l-3.94 3.97a.634.634 0 0 1-.45.188z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "qz961ctn7a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fkhi4ajurb",
    x: 11.75,
    y: 11.75,
    width: 18.5,
    height: 18.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.141176 0 0 0 0 0.894118 0 0 0 0 0.847059 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceVerificationSelect);
export default __webpack_public_path__ + "static/media/face_verification_select.0af5ecc0364e733dab99a798b31614d6.svg";
export { ForwardRef as ReactComponent };